import { SortCondition } from "../models/Work/SortCondition";
export var determinateSort = function (filterCondition) {
    if (filterCondition.createdToMonth !== null || filterCondition.createdFromMonth !== null) {
        return new SortCondition({ sort: 'create_datetime', order: 'DESC' });
    }
    return new SortCondition({
        sort: 'update_datetime',
        order: 'DESC',
    });
};
